import React from 'react'
import PropTypes from 'prop-types'

import MainFirst from './../block/MainFirst'
import WindowsBlock from './../block/WindowsBlock'
import MosquitoNet from './../block/MosquitoNet'
import Podcast from './../block/Podcast'
import Social from './../block/Social'
import Advantages from './../block/Advantages'
import Materials from './../block/Materials'
import WhyWeBest from './../block/WhyWeBest'
import Komfort from './../block/Komfort'
import Showroom from './../block/Showroom'
import Team from './../block/Team'
import OurValues from './../block/OurValues'
import LowPrices from './../block/LowPrices'
import Faq from './../block/Faq'
import Videos from './../block/Videos'
import Reviews from './../block/Reviews'
import WorkClean from './../block/WorkClean'
import Raschet from './../block/Raschet'
import Kontakti from './../block/Kontakti'

class Main extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <MainFirst
          data={data?.main_first || {}}
          protocol={protocol}
          assets_path={assets_path}
        />
        <WindowsBlock
          data={data?.windows_block || {}}
        />
        <MosquitoNet
          data={data?.mosquitonet || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
        />
        <Podcast
          data={data?.podcast || {}}
        />
        <Social
          data={data?.social || {}}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
          vklink={data?.vklink}
          youlink={data?.youlink}
          rutubelink={data?.rutubelink}
        />
        <Advantages
          advantages={data?.advantages || {}}
        />
        <Materials
          data={data?.materials || {}}
        />
        <WhyWeBest />
        <Komfort
          data={data?.komfort || {}}
          assets_path={assets_path}
        />
        <Showroom
          data={data?.showroom || {}}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
          assets_path={assets_path}
        />
        <Team
          data={data?.team || {}}
        />
        <OurValues
          data={data?.ourvalues || {}}
        />
        <LowPrices
          data={data?.lowprices || {}}
          assets_path={assets_path}
        />
        <Faq
          data={data?.faq || {}}
        />
        <Videos
          data={data?.videos || {}}
        />
        <Reviews
          data={data?.reviews || {}}
          logo={data?.logo}
          sitename={data?.sitename}
          assets_path={assets_path}
        />
        <WorkClean
          data={data?.workclean || {}}
          assets_path={assets_path}
        />
        <Raschet
          data={data?.raschet || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
        />
      </>
    )
  }
}

Main.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

Main.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default Main